import pushState from '~/assets/services/windowHistory';

export default function () {
    if (process.browser) {
        pushState('', document.title, window.location.pathname + window.location.search);
    }
}
